export default {
  C: {
    confidence: 90,
    info:
      "Getting down to the nitty-gritty has always been fascinating to me, C is my favorite language",
    projects: [],
  },
  Python: {
    confidence: 95,
    info: "Experience with both 2 and 3, but mostly 3",
    projects: [],
  },
  Java: {
    confidence: 92,
    info: "This is the primary language my college courses focused on",
    projects: [],
  },
  "JavaScript & TypeScript": {
    confidence: 78,
    info:
      "First real programming language, there hasn't been a JavaScript-less month for me since 2018",
    projects: [],
  },
  "Bash & Shell Scripting": {
    confidence: 64,
    info:
      "Linux (Ubuntu) is my primary operating system, I am very comfortable navigating the terminal",
    projects: [],
  },
  "HTML & CSS": {
    confidence: 100,
    info:
      "There are few ways to use JS to its fullest extent without these two knuckleheads",
    projects: [],
  },
  LaTeX: {
    confidence: 55,
    info:
      "I've worked written multiple research papers in my college years, most notably one about the Rubik's Cube",
    projects: [],
  },
  "C++": {
    confidence: 50,
    info:
      "I was a TA for a C++ class, though admittedly I had not written a single line of C++ until the first class period",
    projects: [],
  },
  React: {
    confidence: 72,
    info:
      "This website is written in React, and is effectively my introduction to the language",
    projects: [],
  },
  Angular: {
    confidence: 44,
    info:
      "My high school provided me with an internship program in which I performed some front end programming with Angular 6",
    projects: [],
  },
  MatLab: {
    confidence: 33,
    info:
      "I've helped my Engineer friends with their MatLab homework almost every semester of college",
    projects: [],
  },
  "Assembly (MIPS)": {
    confidence: 24,
    info:
      "While I was taking a Computer Organization coure at school, I spent my free time playing around with the MARS assembler, writing hello world programs and the like",
    projects: [],
  },
  Mathematica: {
    confidence: 33,
    info:
      "A professor I really look up to uses Mathematica all the time, so I got it running on my computer and wrote a few programs",
    projects: [],
  },
  Befunge: {
    confidence: 55,
    info:
      "I had a Befunge competition with a friend of mine, in which we challenged each other to take in an input of any reasonable length (less than 50 if I remember correctly) and print it back out.",
    projects: [],
  },
};
